import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import HomeHero from '../../components/home/HomeHero';
import CompanyStrip from '../../components/home/CompanyStrip';
import PlatformBento from '../../components/home/PlatformBento';
import { MentorSection, Faq, FinalCta, ContactSection } from '../../components/home/HomeSections';
import InterviewPrep from '../../components/home/InterviewPrep';
import CareerGrowth from '../../components/home/CareerGrowth';
import RoadmapBooking from '../../components/home/RoadmapBooking';
import SkillDevelopment from '../../components/home/SkillDevelopment';
import Courses from '../../components/Courses';
import Footer from '../../components/Footer';
import CourseModal from '../../components/CourseModal';
import useScrollReveal from '../../hooks/useScrollReveal';
import './index.css';

// Cards with the `spotlight` class get a glow that follows the cursor.
const handleSpotlight = (e) => {
  const card = e.target.closest?.('.spotlight');
  if (!card) return;
  const rect = card.getBoundingClientRect();
  card.style.setProperty('--mx', `${e.clientX - rect.left}px`);
  card.style.setProperty('--my', `${e.clientY - rect.top}px`);
};

const Home = () => {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const location = useLocation();
  const homeRef = useRef(null);
  useScrollReveal(homeRef);

  // Scroll to a section when arriving via /#section. Sections above the target
  // (e.g. the booking calendar) can still grow as their data loads, so keep the
  // target in place until the page settles or the visitor starts scrolling.
  useEffect(() => {
    if (!location.hash) return undefined;
    const element = document.getElementById(location.hash.slice(1));
    const root = homeRef.current;
    if (!element || !root) return undefined;

    // offsetTop ignores transforms, so a mid-animation scroll reveal can't skew the
    // target; scroll-margin-top (set in CSS) keeps it clear of the fixed navbar
    const align = () => {
      let top = 0;
      for (let el = element; el; el = el.offsetParent) top += el.offsetTop;
      const margin = parseFloat(getComputedStyle(element).scrollMarginTop) || 0;
      window.scrollTo({ top: Math.max(0, top - margin), behavior: 'instant' });
    };
    align();

    const resize = new ResizeObserver(align);
    resize.observe(root);
    const release = () => {
      resize.disconnect();
      clearTimeout(timer);
      ['wheel', 'touchstart', 'keydown'].forEach((type) => window.removeEventListener(type, release));
    };
    const timer = setTimeout(release, 4000);
    ['wheel', 'touchstart', 'keydown'].forEach((type) => window.addEventListener(type, release, { passive: true }));
    return release;
  }, [location.hash]);

  const handleCourseClick = (course) => setSelectedCourse(course);
  const handleCourseClose = useCallback(() => setSelectedCourse(null), []);

  return (
    <div className="home" ref={homeRef} onPointerMove={handleSpotlight}>
      <HomeHero />
      <CompanyStrip />
      <CareerGrowth onCourseClick={handleCourseClick} />
      <RoadmapBooking />
      <SkillDevelopment />
      <InterviewPrep />
      <PlatformBento />
      <Courses onCourseClick={handleCourseClick} />
      <MentorSection />
      <Faq />
      <FinalCta />
      <ContactSection />
      <Footer />
      <CourseModal course={selectedCourse} onClose={handleCourseClose} />
    </div>
  );
};

export default Home;
